{
  "newFeature": "Un’opzione semplificata per cambiare applicazione ora include solo le app per le quali sei abilitato, raccolte in un singolo elenco.",
  "newLayout": "Nuovo layout",
  "ok": "OK"
}
